import { useEffect, useState } from 'react';
import { Map } from "../../../pages/contact/components/map";
import { InputField } from "../../_input/_input";
import { TextArea } from "../../_input/_textArea";
import { FormButton } from "../../_input/_button";
import { useTranslation } from "react-i18next";
import { formValidate } from '../../../utils/validation';
import config from '../../../configuration/config';
import { PhoneInput } from "../../../components/_input/_phoneInput";
import PhoneDropDown from "../../../components/_input/_phoneDropDown";
import { DropDownInput } from '../../../components/_input/_dropdown';
import axios from "axios";
import ContactTile from '../../../pages/contact/components/contactTile';
import { toast } from 'react-toastify';



// Only show map markers for these two cities. Matched against branch
// `content` (localized label) and `name` (id) so it works for AR and EN.
const ALLOWED_BRANCH_KEYWORDS = ["الخبر", "الدمام", "khobar", "dammam", "khubar", "al khobar", "al dammam"];
function isAllowedBranch(b) {
    const haystack = `${b?.name || ""} ${b?.content || ""}`.toLowerCase();
    return ALLOWED_BRANCH_KEYWORDS.some((k) => haystack.includes(k.toLowerCase()));
}

export function NavContact({ ...prop }) {

    const { t: trans, i18n } = useTranslation(["common", "form", "info", "inputs"]);
    let lang = (i18n.language || 'ar');

    const [message, setMessage] = useState({
        fullName: '',
        phone: '',
        email: '',
        subject: '',
        messageContent: ''
    });

    const [branches, setBranches] = useState([]);
    const [contacts, setContacts] = useState([{}]);
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [subjects, setSubjects] = useState([]);

    useEffect(async () => {
        try {
            const response = await axios.request({
                baseURL: config.controllURL,
                url: lang + "/api/contact/contact/",
                method: "get",
            });
            // Only keep Khobar / Dammam — never use the visitor's geolocation
            const filteredBranches = (response.data.branches || []).filter(isAllowedBranch);
            setBranches(filteredBranches);
            setContacts(response.data.contacts);
            setSubjects(response.data.subjects.map(item => { return { text: item.description, value: item.id } }));

        } catch (error) {
            console.log(error);
        }
    }, []);

    useEffect(() => {
        if (branches.length > 0) setSelectedBranch(branches[0]);
    }, [branches]);

    // useEffect(async () => {
    //     if (selectedBranch != null) {
    //         const allContects = contacts.filter(e =>
    //             e.branchId == selectedBranch.name
    //         );
    //         setContacts(allContects);
    //     }
    // }, [selectedBranch]);


    const schema = prop.schema;

    const [error, setError] = useState({});

    const submitRequest = async (e) => {
        e.preventDefault();


        const result = formValidate(schema, message) ?? {};
        setError(result);
        try {
            if (Object.keys(result).length === 0) {
                console.log(Object.keys(error).length);
                const response = await axios.post(
                    `${config.controllURL}${lang}/api/Pages/AddsiteContactMessages`,
                    {
                        "name": message.fullName,
                        "email": message.email,
                        "phoneNumber": message.phone,
                        "subject": Number(message.subject),
                        "message": message.messageContent,
                    }
                );
                if (response.status === 200 || response.status === 201) {
                    const defaultValue = { ...message };
                    setMessage({
                        fullName: '',
                        phone: defaultValue.phone,
                        email: '',
                        subject: '',
                        messageContent: ''
                    });
                    setError({});
                    toast.success(trans("info:message_sent_successfully"));
                }
            }
        } catch (e) {

        }

    }

    return (
        <div className={"nav-mega-menu bg-white box-shadow border-radius  " + prop.className}>
            <div className="my-4 text-20 p-8 border-radius nav-grid-3-cols  nav-grid-contact">
                <div>
                    <form onSubmit={
                        (e) => submitRequest(e)
                    }>
                        <h3 className="nav-heading">
                            {trans("common:contact-us")}
                        </h3>

                        <div>
                            <div className="nav-contact-form mb-8">
                                <InputField
                                    secondary={true}
                                    placeholder={trans("form:name")}
                                    name='fullName'
                                    value={message.fullName}
                                    errorLabel={error?.fullName}
                                    onChangeValue={
                                        (e) => {
                                            const val = { ...message };
                                            val.fullName = e.target.value;
                                            setMessage(val);
                                        }
                                    }
                                />
                                <PhoneDropDown
                                    errorLabel={error?.phone}
                                    onChangeValue={(countryCode, phoneNumber) => {
                                        const val = { ...message };
                                        val.phone = `+${countryCode}${phoneNumber}`;
                                        setMessage(val);
                                    }}
                                />

                                <InputField
                                    placeholder={trans("form:email")}
                                    name='email'
                                    value={message.email}
                                    errorLabel={error?.email}
                                    onChangeValue={
                                        (e) => {
                                            const val = { ...message };
                                            val.email = e.target.value;
                                            setMessage(val);
                                        }
                                    }
                                />
                                <DropDownInput
                                    onSelect={(e) => {
                                        const val = { ...message };
                                        val.subject = String(e);
                                        setMessage(val);
                                    }}
                                    name='subject'
                                    // className={"flex-grow-1"}
                                    defaultOption={{ text: trans("form:subject"), value: 0 }}
                                    options={[...subjects]}
                                    errorLabel={error?.subject}
                                />
                                <TextArea
                                    value={message.messageContent}
                                    placeholder={trans("form:message")}
                                    name='messageContent'
                                    errorLabel={error?.messageContent}
                                    onChangeValue={
                                        (e) => {
                                            console.log(e);
                                            const val = { ...message };
                                            val.messageContent = e;
                                            setMessage(val);
                                        }
                                    }
                                />

                            </div>
                            <FormButton
                                isPrimary={true}
                                classes={" px-10 py-5 text-16 text-bold w-100"}
                                name={trans("form:send")}
                            />
                        </div>
                    </form>
                </div>
                <div className={"nav-grid-middle"}>
                    <h3 className="nav-heading">
                        {trans("common:contact-info")}
                    </h3>

                    <div className="m-8 space-y-6">
                        {
                            contacts?.map((contact, index) => {
                                // if (contact.branchId == selectedBranch?.name)
                                    return (
                                        <ContactTile
                                            key={index}
                                            icon={contact.typeIconPath}
                                            value={contact.contactValue}
                                            type={contact.typeValue}
                                            name={contact.contactTitle ?? contact.typeTitle}
                                        />
                                    );
                            })
                        }

                    </div>
                </div>
                <div>
                    <h3 className="nav-heading">
                        {trans("common:locations")}
                    </h3>
                    <div className=" nav-contact-map">
                        {/* <Map /> */}
                        <Map multiMarkers={true} markers={branches} />
                    </div>
                </div>
            </div>
        </div>
    );
}